import { formulaDropAreaId, END_INSERT } from "./FormulaEditor.types";

interface OverTarget {
  id: string | number;
  rect: { left: number; width: number };
}

export interface InsertTarget {
  beforeUid: string | null;
  barTarget: string;
}

// Single source of truth for both the drag-over preview bar and the drop
// commit, so they can never disagree.
export function resolveInsert(
  over: OverTarget | null,
  pointerX: number,
  chipUids: string[],
): InsertTarget {
  if (!over || over.id === formulaDropAreaId) {
    return { beforeUid: null, barTarget: END_INSERT };
  }

  const overIndex = chipUids.indexOf(String(over.id));
  if (overIndex === -1) return { beforeUid: null, barTarget: END_INSERT };

  const afterMidpoint = pointerX > over.rect.left + over.rect.width / 2;
  const targetIndex = afterMidpoint ? overIndex + 1 : overIndex;
  const beforeUid = chipUids[targetIndex] ?? null;
  return { beforeUid, barTarget: beforeUid ?? END_INSERT };
}
